module.exports = __webpack_public_path__ + "img/waiting_for_others.16705562.svg";